module.exports = __webpack_public_path__ + "img/phone-sm.8ea117f1.svg";